import React from 'react'
import { Canvas, extend } from '@react-three/fiber'
import Character from './Characters'
import { Effects, OrbitControls, Stars } from '@react-three/drei'
import { UnrealBloomPass } from 'three-stdlib'

extend({ UnrealBloomPass })

function App({ dance_id }) {

    return (
        <>
            <Canvas camera={{ fov: 75, near: 0.1, far: 1000, position: [0, 3, 8] }}>
                <ambientLight intensity={2} />
                <directionalLight position={[-2.5, 10, 5]} castShadow intensity={0.5} />
                <Stars radius={100} depth={50} count={5000} factor={4} saturation={0} fade speed={1} />
                <Character dance_id={dance_id} />
                <Effects disableGamma>
                    <unrealBloomPass threshold={1} strength={0.75} radius={0.5} />
                </Effects>
                <OrbitControls enableZoom={false} autoRotate={true} enablePan={false} target={[0, 4, 0]} />
            </Canvas>
        </>
    )
}

export default App
